// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"0f011ef2","208":"2137e072","348":"9fd17389","755":"30b62487","950":"d159a4c7"}[chunkId] + ".css";
};